import { render, staticRenderFns } from "./buy_bom.vue?vue&type=template&id=496e30d2&scoped=true"
import script from "./buy_bom.vue?vue&type=script&lang=js"
export * from "./buy_bom.vue?vue&type=script&lang=js"
import style0 from "./buy_bom.vue?vue&type=style&index=0&id=496e30d2&prod&lang=scss&scoped=true"
import style1 from "./buy_bom.vue?vue&type=style&index=1&id=496e30d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496e30d2",
  null
  
)

export default component.exports